import BaggageTotalPriceBlock from './components/BaggageTotalPriceBlock.css';
export default {
    BaggageTotalPriceBlock
};
